import { toJpeg } from 'html-to-image';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';

import './cashout.scss';
import { useGameReducer } from '../../../Store';
import Header from '../../../Components/Header';
import { DATETIME_FORMAT } from '../../../environment.config';
import { copyToClipboard } from '../../../Utils';
import Notification from '../../../Components/Notification';

export const CashoutPage =  () => {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const gameReducer = useGameReducer();

  const exportRef = useRef<HTMLDivElement>(null);

  const downloadJpeg = async () => {

    console.log(gameReducer.cashout);
    if (!exportRef.current) return;
    const element = exportRef.current;

    const dataUrl = await toJpeg(element, {
      filter: (node) => {
        if (node instanceof HTMLElement) {
          return !node.classList?.contains('no-export');
        }

        return true;
      },
      quality: 0.95,
      width: element.offsetWidth,
      height: element.offsetHeight,
      canvasWidth: element.offsetWidth,
      canvasHeight: element.offsetHeight,
      pixelRatio: 2,
      backgroundColor: '#333333'
    });

    const link = document.createElement('a');
    link.download = 'ticket.jpg';
    link.href = dataUrl;
    link.click();
  };

  useEffect(() => {
    if (!gameReducer.cashout) {
      navigate('/');
    }
  });

  const date = moment(gameReducer.cashout?.date);

  return (
    <div className='page_container cashout_page'>
      <Notification />
      <Header logo={true} name='Play60s'></Header>
      <div className='page_content'>
        <div className="page_subtitle"></div>
        { gameReducer.cashout && <div className='cashout_info' ref={exportRef}>
          <div className='user_info_widget no-animation'>
            <div className='user_name_icon member'></div>
            <div className='user_member_id'>{gameReducer.cashout?.name}</div>
            <div className='user_member_name'>({gameReducer.cashout?.displayName})</div>
          </div>

          <div className="cashout_balance">
            <div className="label">{t('cashout.balance')}</div>

            <div className="value">{gameReducer.cashout.balance ? gameReducer.cashout.balance : 0}</div>
          </div>

          <div className="block">
            <div className="label">{t('cashout.datetime')}</div>
            <div className="value">{date.format(DATETIME_FORMAT)}</div>
          </div>

          <div className="block no-export">
            <div className="action">
              <button className='outlined' onClick={() => copyToClipboard(gameReducer.cashout.name)}>{t('cashout.copy')}</button>
            </div>
          </div>

          <div className="block">
            <div className="label">{t('cashout.id')}</div>
            <div className="value">{gameReducer.cashout.transactionId ? gameReducer.cashout.transactionId : '-'}</div>
          </div>

          <div className="block no-export">
            <div className="action">
              <button className='outlined' onClick={() => downloadJpeg()}>{t('cashout.download')}</button>
            </div>
          </div>
        </div>}
      </div>
    </div>
  );
};
